var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(" number of contracts of separation: "),_c('b-form-select',{staticStyle:{"border":"1px solid gray","width":"auto"},attrs:{"options":_vm.options},model:{value:(_vm.numberOfContractsApart),callback:function ($$v) {_vm.numberOfContractsApart=$$v},expression:"numberOfContractsApart"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }